import { render, staticRenderFns } from "./UpdateQuotation.vue?vue&type=template&id=704825b1&scoped=true&"
import script from "./UpdateQuotation.vue?vue&type=script&lang=js&"
export * from "./UpdateQuotation.vue?vue&type=script&lang=js&"
import style0 from "./UpdateQuotation.vue?vue&type=style&index=0&id=704825b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704825b1",
  null
  
)

export default component.exports